export default __webpack_public_path__ + "static/media/About-us-banner.7ed97500.png";